'use client'
import React, { useState } from 'react'
import parse from 'html-react-parser';
import tailwindConfig from '@tailwind.config'


const AboutComponent = ({ html }) => {
    const style = {
        color: tailwindConfig.theme.extend.colors.secondary,
    };
    const style2 = {
        color: tailwindConfig.theme.extend.colors.secondary,
        overflow: 'hidden',
        z: 10
    };





    return (
        <div className='mb-2 pb-2'>
            <div style={style2} className=' px-2'>
                {parse(`${html}`)}
            </div>
        </div>
    )
}

export default AboutComponent